// Shared types between Worker and frontend.
// Frontend imports these via a relative path during build.

export type Property = 'ALL' | 'HC_SG' | 'HKA_SG' | 'BALI' | 'HKA_TH' | 'HC_HK' | 'HG' | 'GP_PODCAST';

export const PROPERTIES: { id: Property; label: string }[] = [
  { id: 'ALL', label: 'All properties' },
  { id: 'HC_SG', label: 'Honeycombers SG' },
  { id: 'HKA_SG', label: 'HoneyKids Singapore' },
  { id: 'BALI', label: 'Honeycombers Bali' },
  { id: 'HKA_TH', label: 'HoneyKids Thailand' },
  { id: 'HC_HK', label: 'Honeycombers Hong Kong' },
  { id: 'HG', label: 'HoneyGlow' },
  { id: 'GP_PODCAST', label: 'GP Podcast' },
];

export type RAGStatus = 'green' | 'amber' | 'red';

export interface WeeklySnapshot {
  week_ending: string;
  property: Property;
  total_sessions: number | null;
  organic_sessions: number | null;
  avg_page_rank: number | null;
  posts_published: number | null;
  avg_time_on_page_seconds: number | null;
  geo_citations: number | null;
  keywords_top_3: number | null;
  keywords_top_3_delta: number | null;
}

export interface MoneyPage {
  week_ending: string;
  property: Property;
  url: string;
  title: string | null;
  target_keyword: string | null;
  avg_position: number | null;
  position_delta: number | null;
  sessions: number | null;
  revenue_aud: number | null;
  revenue_delta_pct: number | null;
}

export interface SourceStatus {
  name: string;
  enabled: boolean;
  last_run_at: string | null;
  last_status: 'success' | 'failed' | 'never_run';
  reason_disabled?: string;
}
